/* The exercise card's ⋯ and the 🗑 beside it, as `Builder planu - tydzien - programator` draws
 * them: the ⋯ is a BARE glyph at 13px on `--text-3` with no box at all, and the trash is a 22px
 * square with a 6px radius, also boxless, carrying a 13px stroke. The 02.08 gallery's bordered
 * 22px square is gone with the redraw — it read as a control the mock does not have. */

.trigger {
  position: relative;
  display: grid;
  flex: none;
  place-items: center;
  padding: var(--space-0);
  font-size: var(--fs-exercise);
  font-weight: var(--fw-regular);
  line-height: var(--lh-none);
  color: var(--text-3);
  background: transparent;
  border: 0;
  border-radius: var(--space-0);
}

/* The pointer target the 22px square does not carry on its own — WCAG 2.2 SC 2.5.8's floor, bought
 * with a pseudo-element so the gallery's geometry ships unchanged. */
.trigger::after {
  position: absolute;
  inset: var(--hit-extend);
  content: "";
}

.trigger:hover {
  color: var(--text);
}

.trigger:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.trigger[data-popup-open] {
  color: var(--text);
}

.remove {
  position: relative;
  display: grid;
  flex: none;
  place-items: center;
  width: 22px;
  height: 22px;
  padding: var(--space-0);
  color: var(--text-3);
  cursor: pointer;
  background: transparent;
  border: 0;
  border-radius: var(--radius-xs);

  /* See `ExerciseBlock`'s `--icon-ink`: stylelint accepts no `currentcolor` on a `stroke`. */
  --remove-ink: var(--text-3);
}

.remove::after {
  position: absolute;
  inset: var(--hit-extend);
  content: "";
}

.remove:hover {
  --remove-ink: var(--text);

  color: var(--text);
}

.remove[aria-disabled='true'] {
  cursor: default;
  opacity: 0.4;
}

.remove:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.removeIcon {
  display: block;
  width: 13px;
  height: 13px;
  stroke: var(--remove-ink);
  fill: none;
}

/* The drawing beside each ⋯ entry — the mobile registry's own glyphs at the house construction, in
 * the item's own ink so a refused entry's icon dims with its words rather than staying at full
 * strength beside them. 16px against the 13px label: the drawing is a landmark for scanning the
 * list, not a second statement of it. */
.itemIcon {
  flex: none;
  width: 16px;
  height: 16px;
}
